module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/customer-style1/customer-style1.component.scss
// module id = ./src/app/customers/customer-style1/customer-style1.component.scss
// module chunks = main